import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {PrestatieDienstenComponent} from './prestatie-diensten/prestatie-diensten.component';
import {PrestatieTakenComponent} from './prestatie-taken/prestatie-taken.component';
import {PrestatieTakenSelectComponent} from './prestatie-taken/taken-select/prestatie-taken-select.component';
import {PrestatieHeaderComponent} from './prestatie-header/prestatie-header.component';
import {PrestatieDatumPipe} from './prestatie-datum.pipe';
import {DatePipe} from '@angular/common';
import {PrestatieUurPipe} from './prestatie-uur.pipe';
import {PrestatieZoekmethodeIconPipe} from './prestatie-zoekmethode-icon.pipe';
import {DienstModule} from '../dienst/dienst.module';
import {PrestatiesComponent} from './prestaties/prestaties.component';

@NgModule({
  declarations: [
    PrestatieDatumPipe,
    PrestatieUurPipe,
    PrestatieZoekmethodeIconPipe,
    PrestatieDienstenComponent,
    PrestatieTakenComponent,
    PrestatieTakenSelectComponent,
    PrestatieHeaderComponent,
    PrestatiesComponent
  ],
  imports: [
    CoreModule,
    DienstModule,
  ],
  exports: [
    PrestatieDatumPipe,
    PrestatieUurPipe,
    PrestatieZoekmethodeIconPipe,
    PrestatieDienstenComponent,
    PrestatieTakenComponent,
    PrestatieHeaderComponent,
    PrestatiesComponent,
  ],
  providers: [
    DatePipe,
    PrestatieDatumPipe,
    PrestatieUurPipe,
    PrestatieZoekmethodeIconPipe,
  ],
})
export class PrestatieModule {
}
